import { useSelector } from "react-redux";
import { featureFlagSelector, FeatureFlagState } from "./featureFlagReducer";

export function useFeature(feature: keyof FeatureFlagState) {
    const state = useSelector(featureFlagSelector) || {};
    return state[feature];
}
